import React, { useEffect, useState } from 'react';
import { InputInfo, OutcomeInfo, OutcomeOptions } from '../../../models/APIModels';
import { Grid, Box, TextField } from '@mui/material';
import { cloneDeep } from 'lodash';

interface IProps {
  selectedOutcome: OutcomeInfo;
  selectedOption: OutcomeOptions;
  updateOptionConfiguration: (selectedOutcome: OutcomeInfo, selectedOption: OutcomeOptions) => void;
  disabled?: boolean;
}
const OutcomeOptionConfiguration = ({ selectedOutcome, selectedOption, updateOptionConfiguration, disabled }) => {
  const [optionFriendlyName, setOptionFriendlyName] = useState('');
  const [optionValue, setOptionValue] = useState('');

  const onOptionTextChange = (event, field) => {
    const cloneInput = cloneDeep(selectedOutcome);
    const value = event.target.value;
    const index = selectedOutcome.options.findIndex(
      (o) => selectedOption && o.optionFriendlyName === selectedOption.optionFriendlyName
    );
    if (index >= -1) {
      const toSaveOption = cloneInput.options[index];
      if (field === 'optionFriendlyName') {
        toSaveOption[field] = value;
        setOptionFriendlyName(value);
      } else if (field === 'optionValue') {
        toSaveOption[field] = value;
        setOptionValue(value);
      }
      updateOptionConfiguration(cloneInput, toSaveOption);
    }
  };
  useEffect(() => {
    setOptionFriendlyName(selectedOption && selectedOption.optionFriendlyName ? selectedOption.optionFriendlyName : '');
    setOptionValue(selectedOption && selectedOption.optionValue ? selectedOption.optionValue : '');
  }, [selectedOption]);

  useEffect(() => {}, [selectedOutcome]);

  return (
    <Grid container spacing={1} direction="row" sx={{ paddingTop: 1 }}>
      <Grid item xs={12}>
        <Box className="hedading">
          <div className="title">Option Configuration</div>
          <div className="line"></div>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="name"
          label="Option Friendly Name"
          onChange={(e) => onOptionTextChange(e, 'optionFriendlyName')}
          variant="outlined"
          placeholder=""
          size="small"
          fullWidth
          value={optionFriendlyName}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="optionValue"
          label="Option Value"
          onChange={(e) => onOptionTextChange(e, 'optionValue')}
          variant="outlined"
          placeholder=""
          size="small"
          fullWidth
          value={optionValue}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

export default OutcomeOptionConfiguration;
